import * as ActionTypes from 'Redux/Actions/EnumTypes/ActionEnumTypes';
import * as ErrorActionModel from 'Redux/Actions/Models/ErrorActionModel';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import API from "Connectors/_main";

function clearErrorStore(): ErrorActionModel.ClearErrors {
    return {
        type: ActionTypes.ERORR.CLEAR_ERRORS
    };
}

function setRequestConfig(requestData: AxiosRequestConfig): ErrorActionModel.SetRequestConfig {
    return {
        type: ActionTypes.ERORR.SET_RQ_CONFIG,
        payload: {
            requestData
        }
    };
}

function setResponseError(responseError: AxiosResponse, unknownError?: boolean): ErrorActionModel.SetResponseError {
    return {
        type: ActionTypes.ERORR.SET_RQ_RESPONSE_ERR,
        payload: {
            responseError,
            unknownError
        }
    };
}
function requestSuccess(responseSuccess: AxiosResponse): ErrorActionModel.ResponseSuccess {
    return {
        type: ActionTypes.ERORR.RESPONSE_SUCCESS,
        payload: {
            responseSuccess
        }
    };
}

function setNewsForMoment(news: ErrorActionModel.News) {
    return async dispatch => {
        dispatch(setNews(news));
        setTimeout(() => {
            dispatch(setNews(null));
        }, 10000);
    };
}

function setNews(news: ErrorActionModel.News): ErrorActionModel.SetNews {
    return {
        type: ActionTypes.ERORR.SET_NEWS,
        payload: {
            news
        }
    };
}
function setSSEResponseError(sseResponseError: any): ErrorActionModel.SetSSEResponseError {
    return {
        type: ActionTypes.ERORR.SET_SSE_RQ_RESPONSE_ERR,
        payload: {
            sseResponseError
        }
    };
}


function unauthorizedUser(): ErrorActionModel.UnauthorizedUserAction {
    localStorage.clear();
    API.defaults.headers.common['Authorization'] = ``;
    return {
        type: ActionTypes.ERORR.UNAUTHORIZED_USER
    };
}

export { clearErrorStore, setRequestConfig, setResponseError, requestSuccess, setNewsForMoment, setSSEResponseError, unauthorizedUser };



// WEBPACK FOOTER //
// ./src/Redux/Actions/ErrorActions.ts